import { useEffect, useState, useCallback } from 'react';
import { Container } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { filterMenuItems } from '../../../Data/Layout/SidebarMenuList';
import menuList from '../../../Data/Layout/SidebarMenuList';
import { decryptData } from '../../../Tools/Cipher/EncryptData';

function CompanyVerify() {
    const navigate = useNavigate();
    const location = useLocation();
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [firstMenuUrl, setFirstMenuUrl] = useState<string | null>(null);

    // ✅ Memoize navigate to avoid unnecessary re-renders
    const safeNavigate = useCallback((path: string) => {
        navigate(path);
    }, [navigate]);

    useEffect(() => {
        const handleLoad = () => setIsPageLoaded(true);

        if (document.readyState === "complete") {
            handleLoad();
        } else {
            window.addEventListener("load", handleLoad);
            return () => {
                window.removeEventListener("load", handleLoad);
            };
        }
    }, []);

    useEffect(() => {
        if (!isPageLoaded) return;

        const resourceList: string[] = decryptData(localStorage.getItem("resourceList"));

        if (!resourceList.length) {
            safeNavigate("/");
            return;
        }
        console.log(menuList, "menuList")
        let filteredMenuList = filterMenuItems(menuList, resourceList);
        console.log(filteredMenuList, "filteredMenuList")

        const findFirstLink = (menu: any[]): string | null => {
            for (let item of menu) {
                if (item.type === "link" && item.url) {
                    return item.url;
                } else if (item.menu) {
                    const nestedUrl = findFirstLink(item.menu);
                    if (nestedUrl) return nestedUrl;
                }
            }
            return null;
        };

        console.log(findFirstLink(filteredMenuList) || "/", "qwerty")
        if (filteredMenuList.length > 0) {
            setFirstMenuUrl(findFirstLink(filteredMenuList) || "/");
        } else {
            setFirstMenuUrl("/");
        }
    }, [isPageLoaded, safeNavigate]); // ✅ Now uses memoized safeNavigate

    useEffect(() => {
        if (firstMenuUrl !== null) {
            console.log("firstMenuUrl", "firstMenuUrl", firstMenuUrl)
            setTimeout(() => {
                console.log("Navigating to:", firstMenuUrl);
                navigate(firstMenuUrl);  // ✅ Directly calling without `useCallback`
                window.location.reload()
            }, 1000);
        }
    }, [firstMenuUrl, safeNavigate, location.pathname]); // ✅ Now uses memoized safeNavigate

    return (
        <div className='page-body' style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <Container fluid>
                {!firstMenuUrl && <div className="loader"></div>} {/* ✅ Show Loader only when loading */}
            </Container>

            {/* Loader CSS */}
            <style>
                {`
                .loader {
                    width: 50px;
                    height: 50px;
                    border: 5px solid #f3f3f3;
                    border-top: 5px solid #3498db;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
            </style>
        </div>
    );
}

export default CompanyVerify;
